<template>
  <Teleport to="body">
    <div
      class="modal-overlay"
      :class="{ mobile: isMobile || isTablet }"
      @click.self="closeModal"
    >
      <div class="modal" @click.stop v-bind="$attrs">
        <div class="img-wrapper">
          <slot name="background-image"></slot>
          <img
            v-if="img && !$slots['background-image']"
            :src="require(`@/assets/${img}`)"
            alt="BG"
          />
        </div>
        <div class="wrapper">
          <div class="close" @click="closeModal">
            <Vector />
          </div>
          <h3>{{ name }}</h3>
          <slot></slot>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import Vector from "@/components/icons/Vector.vue"
import { useWindowSize } from "@/composables/useWindowSize"

export default defineComponent({
  components: { Vector },
  name: "ModalComponent",
  props: {
    name: {
      type: String,
      required: true,
    },
    img: {
      type: String,
    },
  },
  emits: ["close"],
  setup(_, { emit }) {
    const closeModal = () => {
      emit("close")
    }

    const { isTablet, isMobile } = useWindowSize()

    return {
      closeModal,
      isTablet,
      isMobile,
    }
  },
})
</script>
<style lang="scss">
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(12px);

  padding: 16px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  .modal {
    display: flex;
    position: absolute;
    max-width: 100%;
    padding: 32px;
    box-sizing: border-box;
    background: #212429;
    box-shadow: var(--black-shadow);
    border-radius: 24px;
    overflow: hidden;
    max-height: 98dvh;

    .wrapper {
      display: flex;
      flex-direction: column;
      gap: 40px;
      z-index: 1;
      width: 100%;
    }
    .img-wrapper {
      border-radius: 24px;
      position: absolute;
      top: 0;
      left: 0;
      height: 160px;
      overflow: hidden;
      z-index: 0;

      img {
        margin-top: -50px;
        width: 100%;
      }

      &::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0px;
        top: 0px;

        background: linear-gradient(
          180deg,
          rgba(33, 36, 41, 0) 25.77%,
          rgba(33, 36, 41, 0.878157) 61.02%,
          #212429 94.52%
        );
      }

      &::before {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0px;
        top: 0px;

        background: linear-gradient(
          260.99deg,
          rgba(33, 36, 41, 0) 47.19%,
          rgba(33, 36, 41, 0.878157) 67.13%,
          #212429 86.09%
        );
      }
    }

    h3 {
      font-family: "Druk Text Wide Cyr";
      font-weight: 1000;
      font-size: 20px;
      line-height: 24px;
      letter-spacing: -0.02em;

      color: #ffffff;
    }

    .close {
      cursor: pointer;
      position: absolute;
      width: 20px;
      height: 20px;
      right: 24px;
      top: 24px;
    }
  }
}
.modal-overlay.mobile {
  .modal {
    padding: 16px;

    .wrapper {
      gap: 3rem;
      .close {
        right: 12px;
        top: 12px;
      }
    }
  }
}
</style>
<style>
.modal-overlay:not(:last-child) {
  opacity: 0;
}
</style>
